import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { useNavigate } from '@thd-olt-component-react/router';
import { BundleAlertmessage } from './subcomponents/BundleAlertmessage';
import { BundleVariantChangeAlert } from './subcomponents/BundleVariantChangeAlert';
import { isBundleUnavailable, bundleHasOOSProduct } from '../utils/product-unavailable-utils';

const BundleAlert = ({
  product,
  alertSize,
  alertBodyText,
  alertHeadline,
  products
}) => {

  const {
    hidePrice, brandUrl, shopMoreLinkText, unavailableBundleMessageText, unavailableAlertStatus,
    unavailableAlertAdditionalText, unavailableAlertHeadline, unavailableShopMoreLink
  } = product?.features || {};
  const hasOOsProduct = bundleHasOOSProduct({ products });
  const isUnavailable = !hasOOsProduct && hidePrice && isBundleUnavailable({ products });

  const navigate = useNavigate();

  const navigateToPackage = () => {
    navigate(unavailableShopMoreLink || brandUrl);
  };

  if (isUnavailable) {
    return (
      <div className="sui-w-full sui-flex sui-flex-col sui-gap-4" data-testid="bundle-unavailable">
        <Typography variant="h2">{unavailableBundleMessageText}</Typography>
        <BundleAlertmessage
          bundleProduct={product}
          alertSize="large"
          alertBodyText={unavailableAlertAdditionalText}
          alertHeadline={unavailableAlertHeadline}
          status={unavailableAlertStatus}
          shopMoreLinkText={shopMoreLinkText}
          navigateToPackage={navigateToPackage}
        />
      </div>
    );
  }

  return (
    <div data-component="BundleAlert">
      <BundleVariantChangeAlert
        bundleProduct={product}
        alertSize={alertSize}
        alertBodyText={alertBodyText}
        alertHeadline={alertHeadline}
        showPageLevelAlert
      />
    </div>
  );
};

BundleAlert.propTypes = {
  alertSize: string,
  alertBodyText: string,
  alertHeadline: string,
  product: shape({}).isRequired,
  products: arrayOf(
    shape({})
  ).isRequired
};

BundleAlert.defaultProps = {
  alertBodyText: null,
  alertHeadline: null,
  alertSize: 'small'
};

BundleAlert.displayName = 'BundleAlert';

export { BundleAlert };